import type { Template } from "@/types";

export const PO_03_H2_V1: Template[] = [
    {
        id: "po-03-h2v2-01",
        name: "PO 01 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 242, width: 546, height: 432, rotation: 0, imageRotation: 0 },
            { id: "2", x: 554, y: 242, width: 268, height: 432, rotation: 0, imageRotation: 0 },
            { id: "3", x: 830, y: 242, width: 544, height: 432, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-02",
        name: "PO 02 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 62, y: 262, width: 496, height: 392, rotation: 0, imageRotation: 0 },
            { id: "2", x: 566, y: 262, width: 244, height: 392, rotation: 0, imageRotation: 0 },
            { id: "3", x: 818, y: 262, width: 494, height: 392, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-03",
        name: "PO 03 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 242, width: 545, height: 432, rotation: 0, imageRotation: 0 },
            { id: "2", x: 553, y: 242, width: 545, height: 432, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1107, y: 242, width: 268, height: 432, rotation: 0, imageRotation: 0 }
           
        ],
    },

    {
        id: "po-03-h2v2-04",
        name: "PO 04 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 116, y: 171, width: 873, height: 573, rotation: 0, imageRotation: 0 },
            { id: "2", x: 997, y: 171, width: 261, height: 392, rotation: 0, imageRotation: 0 },         
            { id: "3", x: 997, y: 571, width: 261, height: 173, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-05",
        name: "PO 05 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_05.png",
        size: [1374, 916],
        style: {},
        slots: [          
            { id: "1", x: 198, y: 111, width: 501, height: 343, rotation: 0, imageRotation: 0 },
            { id: "2", x: 198, y: 462, width: 501, height: 343, rotation: 0, imageRotation: 0 },
            { id: "3", x: 707, y: 111, width: 468, height: 694, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-06",
        name: "PO 06 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 93, y: 111, width: 501, height: 343, rotation: 0, imageRotation: 0 },
            { id: "2", x: 93, y: 462, width: 501, height: 343, rotation: 0, imageRotation: 0 },
            { id: "3", x: 797, y: 111, width: 467, height: 695, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-03-h2v2-07",
        name: "PO 07 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 65, y: 72, width: 556, height: 383, rotation: 0, imageRotation: 0 },
            { id: "2", x: 65, y: 463, width: 556, height: 382, rotation: 0, imageRotation: 0 },
            { id: "3", x: 771, y: 72, width: 520, height: 773, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-03-h2v2-08",
        name: "PO 08 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 110, y: 111, width: 467, height: 695, rotation: 0, imageRotation: 0 },
            { id: "2", x: 780, y: 111, width: 501, height: 343, rotation: 0, imageRotation: 0 },
            { id: "3", x: 780, y: 462, width: 501, height: 343, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-09",
        name: "PO 09 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 242, width: 268, height: 432, rotation: 0, imageRotation: 0 },
            { id: "2", x: 276, y: 242, width: 545, height: 432, rotation: 0, imageRotation: 0 },
            { id: "3", x: 829, y: 242, width: 545, height: 432, rotation: 0, imageRotation: 0 },
        ],
    },


];

